/**
 * Helper function that converts strings to numbers.
 * If the string is undefined or parsing fails, NaN is returned.
 * @param value Mainly intended to be used with ECS values
 * @returns NaN or the parsed number
 */
export function parseIntOrNaN(value) {
    if (value === undefined) {
        return NaN;
    }
    var parsed = parseInt(value);
    return Number.isNaN(parsed) ? NaN : parsed;
}
//# sourceMappingURL=parseIntOrNaN.js.map